import styled from 'styled-components';
import { TextField, Button, FormControlLabel } from '@mui/material';
import colors from '../../../../../styles/colors';

const ContentWrapper = styled.div`
  padding: 16px;
  height: 100%;
  width: 60%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  background-color: ${colors.base.gamma};
`;

const BirthdayMessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 25px;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
`;

const StyledTextField = styled(TextField)`
  width: 100%;
`;

const StyledButton = styled(Button)`
  margin: 10px 0;
  width: 250px;
  text-transform: none;
`;

const StyledFormControlLabel = styled(FormControlLabel)`
  margin: 8px 0;
`;

export {
  ContentWrapper,
  InputContainer,
  StyledTextField,
  StyledButton,
  BirthdayMessageContainer,
  StyledFormControlLabel,
};
